import type { SuggestionSet } from "../Chat/SlashMenu";

// Generic, one-off chat starters shown in the composer’s “/” menu.
export const chatSuggestions: SuggestionSet = {
  header: "Try asking…",
  items: [
    {
      id: "catch-up",
      icon: "sparkles",
      label: "Catch me up on my day",
      prompt:
        "Catch me up on everything that needs my attention across my tools today.",
    },
    {
      id: "assigned",
      icon: "list-todo",
      label: "What’s assigned to me right now?",
      prompt:
        "What tasks, tickets, and pull requests are assigned to me right now across my tools?",
    },
    {
      id: "summarize",
      icon: "message-circle",
      label: "Summarize a conversation or thread",
      prompt:
        "Summarize the latest activity in a channel, ticket, or thread — ask me which one.",
    },
    {
      id: "find",
      icon: "search",
      label: "Find something across my tools",
      prompt:
        "Help me find something across my connected tools — ask me what I’m looking for.",
    },
    {
      id: "status-update",
      icon: "newspaper",
      label: "Draft a status update",
      prompt:
        "Draft a status update summarizing what I’ve worked on across my tools this week.",
    },
    {
      id: "prep-meeting",
      icon: "calendar",
      label: "Prep me for my next meeting",
      prompt:
        "Help me prep for my next meeting using my calendar and any related docs or tickets.",
    },
    {
      id: "investigate",
      icon: "bug",
      label: "Investigate an issue",
      prompt:
        "Help me investigate an issue — pull together the relevant alerts, logs, and context from my tools.",
    },
  ],
};
